import Container from "../components/Container";
import * as React from "react";
import { useState } from "react";
import { Header } from "../components/Page";
import JSONEditor from "../components/JSONEditor";
import Button from "../components/Button";
import { functions, storage } from "firebase/app";
import { RouteComponentProps } from "react-router";

const ExportCSV = ({
  match
}: RouteComponentProps<{ collection: "products" | "services" }>) => {
  const [exporting, setExporting] = useState(false);
  const { collection } = match.params;
  const template = `templates/exportCSV_${collection}`;
  return (
    <Container>
      <Header
        selected={
          collection === "products" ? "Export Products" : "Export Services"
        }
      />
      <JSONEditor
        key={template}
        path={template}
        extraButton={edited => (
          <Button
            loading={exporting}
            style={{ marginLeft: 10 }}
            primary={true}
            disabled={edited}
            title="Export"
            onPress={async () => {
              try {
                setExporting(true);
                const { url } = (await functions().httpsCallable(
                  "siteAdmin-exportCSV"
                )({
                  template
                })).data;
                const downloadLink = await storage()
                  .ref(url)
                  .getDownloadURL();
                const link = document.createElement("a");
                link.download = "data.csv";
                link.href = downloadLink;
                link.click();
                link.remove();
              } catch (e) {
                alert(JSON.stringify(e));
              } finally {
                setExporting(false);
              }
            }}
          />
        )}
      />
    </Container>
  );
};

export default ExportCSV;
